import { type CanMatchFn, type UrlSegment } from '@angular/router';
import { NavigateRoutes } from '@dro/app/core';
import { inject } from '@angular/core';
import { IncidentStore } from '@dro/app/features/citation/data';

export const workflowCanMatch: CanMatchFn = (_, segments: Array<UrlSegment>): boolean => {
  if (!segments.length) return true;
  const incidentStore = inject(IncidentStore);
  const isArmedForces = incidentStore.isArmedForces();
  const isCaliforniaTraffic = incidentStore.isCaliforniaTraffic();

  if (!isArmedForces && !isCaliforniaTraffic) {
    return true;
  }

  return [
    NavigateRoutes.INCIDENT,
    NavigateRoutes.E_TICKET,
    NavigateRoutes.LOCATION,
    NavigateRoutes.OTHER_INFO,
  ].includes(segments[0].path as NavigateRoutes);
};
